import emptyInbox from "assets/illustrations/chatEmptyInbox.svg"
import { useTranslation } from "react-i18next"
import s from "./EmptyThread.module.scss"

type EmptyThreadProps = {
  onNewMessage: () => void
}

/** The thread pane with nothing open — the design's prompt to start something. */
export function EmptyThread({ onNewMessage }: EmptyThreadProps) {
  const { t } = useTranslation()

  return (
    <div className={s.emptyThread}>
      <img className={s.emptyThread__illustration} src={emptyInbox} alt="" />
      <p className={s.emptyThread__text}>{t("chat.EMPTY_THREAD")}</p>
      <button
        className={s.emptyThread__action}
        type="button"
        onClick={onNewMessage}
      >
        {t("chat.NEW_MESSAGE")}
      </button>
    </div>
  )
}
